import { render, staticRenderFns } from "./PaperManageTable.vue?vue&type=template&id=c0c76870&scoped=true"
import script from "./PaperManageTable.vue?vue&type=script&lang=js"
export * from "./PaperManageTable.vue?vue&type=script&lang=js"
import style0 from "./PaperManageTable.vue?vue&type=style&index=0&id=c0c76870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c76870",
  null
  
)

export default component.exports